import { useEffect, useState } from "react";
import { useGetDataMutation } from "../../../../features/reduxworkbook/dataApiSlice";
// import { useSelector } from 'react-redux';
// import { getL2SheetProperty, getWorkbookProperty } from '../../../../features/reduxworkbook/WorkbookSlice';

// const verifyAllTotalsFetched = ({
//     rowTotalsFetched,
//     columnTotalsFetched,
//     grandTotalsFetched,
//     combinedData,
//     grandTotalRequired,
//     columnTotalRequired,
//     rowTotalRequired
// }) => {
//     console.log(rowTotalsFetched, columnTotalsFetched, grandTotalsFetched, combinedData);
//     let rowsReady = false;
//     let columnReady = false;
//     let grandReady = false;

//     // Check row
//     if (rowTotalRequired) {
//         if (rowTotalsFetched && combinedData.rowTotals) {
//             rowsReady = true;
//         }
//     } else {
//         rowsReady = true;
//     }

//     if (columnTotalRequired) {
//         if (columnTotalsFetched && combinedData.columnTotals) {
//             columnReady = true;
//         }
//     } else {
//         columnReady = true;
//     }

//     if (grandTotalRequired) {
//         if (grandTotalsFetched && combinedData.grandTotals) {
//             grandReady = true;
//         }
//     } else {
//         grandReady = true;
//     }

//     const allReady = rowsReady && columnReady && grandReady;
//     return allReady;
// };


// export const useFetchTotalsFromApi = (props) => {
//     const { grandTotalRequired, columnTotalRequired, rowTotalRequired, rowTotalQuery, columnTotalQuery, grandTotalQuery } = props;



//     const [getData, { data, isLoading, isSuccess, isError, error }] = useGetDataMutation();

//     console.log("outside code running");

//     // State to store the combined data for row, column, and grand totals
//     const [combinedData, setCombinedData] = useState({
//         rowTotals: null,
//         columnTotals: null,
//         grandTotals: null,
//     });



//     // States to track if each API call has been completed
//     const [rowTotalsFetched, setRowTotalsFetched] = useState(false);
//     const [columnTotalsFetched, setColumnTotalsFetched] = useState(false);
//     const [grandTotalsFetched, setGrandTotalsFetched] = useState(false);
//     useEffect(() => {
//         console.log("sending request");
//         if (columnTotalRequired) {
//             setRowTotalsFetched(false);
//             getData(columnTotalQuery)
//                 .unwrap()
//                 .then((data) => {
//                     setCombinedData((prevData) => ({
//                         ...prevData,
//                         columnTotals: data,
//                     }));
//                     setRowTotalsFetched(true);
//                 })
//                 .catch((err) => {
//                     console.error("Error fetching row totals", err);
//                 });
//         } else {
//             setRowTotalsFetched(true);
//         }

//         if (grandTotalRequired) {
//             console.log("grandTotal");
//             setGrandTotalsFetched(false);

//             getData(grandTotalQuery)
//                 .unwrap()
//                 .then((data) => {
//                     setCombinedData((prevData) => ({
//                         ...prevData,
//                         grandTotals: data,
//                     }));
//                     setGrandTotalsFetched(true);
//                 })
//                 .catch((err) => {
//                     console.error("Error fetching row totals", err);
//                 });
//         } else {
//             setGrandTotalsFetched(true);
//         }

//         if (rowTotalRequired) {
//             setColumnTotalsFetched(false);
//             getData(rowTotalQuery)
//                 .unwrap()
//                 .then((data) => {
//                     setCombinedData((prevData) => ({
//                         ...prevData,
//                         rowTotals: data,
//                     }));
//                     setColumnTotalsFetched(true);
//                 })
//                 .catch((err) => {
//                     console.error("Error fetching row totals", err);
//                 });
//         } else {
//             setColumnTotalsFetched(true);

//         }



//     }, [grandTotalRequired, columnTotalRequired, rowTotalRequired])

//     if (!grandTotalRequired && !columnTotalRequired && !rowTotalRequired) return {
//         data: [],
//         isLoading: false,
//         isSuccess: true,
//         isError: false,
//         error: "no error",
//     }
//     const finalIsLoading = isLoading || !rowTotalsFetched || !columnTotalsFetched || !grandTotalsFetched;
//     const IsverifyAllTotalsFetched = verifyAllTotalsFetched({ rowTotalsFetched, columnTotalsFetched, grandTotalsFetched, combinedData, grandTotalRequired, columnTotalRequired, rowTotalRequired })
//     const finalIsSuccess = isSuccess && rowTotalsFetched && columnTotalsFetched && grandTotalsFetched && IsverifyAllTotalsFetched;
//     const finalIsError = isError;
//     console.log("returnig code");
//     if (finalIsSuccess) {
//         console.log(combinedData);

//     }

//     return {
//         data: combinedData,
//         isLoading: finalIsLoading,
//         isSuccess: finalIsSuccess,
//         isError: finalIsError,
//         error
//     };
// };


const verifyAllTotalsFetched = ({
    rowTotalsFetched,
    columnTotalsFetched,
    grandTotalsFetched,
    combinedData,
    grandTotalRequired,
    columnTotalRequired,
    rowTotalRequired
}) => {
    const rowsReady = !rowTotalRequired || (rowTotalsFetched && combinedData.rowTotals);
    const columnsReady = !columnTotalRequired || (columnTotalsFetched && combinedData.columnTotals);
    const grandReady = !grandTotalRequired || (grandTotalsFetched && combinedData.grandTotals);

    return rowsReady && columnsReady && grandReady;
};

export const useFetchTotalsFromApi = ({
    grandTotalRequired,
    columnTotalRequired,
    rowTotalRequired,
    rowTotalQuery,
    columnTotalQuery,
    grandTotalQuery
}) => {
    const [getData] = useGetDataMutation();

    // Combined data and fetch status states
    const [combinedData, setCombinedData] = useState({
        rowTotals: null,
        columnTotals: null,
        grandTotals: null,
    });

    const [fetchStatus, setFetchStatus] = useState({
        rowTotalsFetched: !rowTotalRequired,
        columnTotalsFetched: !columnTotalRequired,
        grandTotalsFetched: !grandTotalRequired,
    });

    // Helper function to fetch data
    const fetchData = (query, key) => {
        if (!query) return;

        setFetchStatus((prev) => ({ ...prev, [`${key}Fetched`]: false }));
        getData(query)
            .unwrap()
            .then((data) => {
                setCombinedData((prev) => ({ ...prev, [key]: data }));
                setFetchStatus((prev) => ({ ...prev, [`${key}Fetched`]: true }));
            })
            .catch((err) => {
                console.error(`Error fetching ${key}`, err);
            });
    };

    // Fetch totals based on requirements
    useEffect(() => {
        if (rowTotalRequired) fetchData(rowTotalQuery, "rowTotals");
        if (columnTotalRequired) fetchData(columnTotalQuery, "columnTotals");
        if (grandTotalRequired) fetchData(grandTotalQuery, "grandTotals");
    }, [grandTotalRequired, columnTotalRequired, rowTotalRequired]);

    // Early return for no totals required
    if (!grandTotalRequired && !columnTotalRequired && !rowTotalRequired) {
        return {
            data: [],
            isLoading: false,
            isSuccess: true,
            isError: false,
            error: "no error",
        };
    }

    const { rowTotalsFetched, columnTotalsFetched, grandTotalsFetched } = fetchStatus;

    // Determine final states
    const finalIsLoading = !rowTotalsFetched || !columnTotalsFetched || !grandTotalsFetched;
    const allTotalsFetched = verifyAllTotalsFetched({
        rowTotalsFetched,
        columnTotalsFetched,
        grandTotalsFetched,
        combinedData,
        grandTotalRequired,
        columnTotalRequired,
        rowTotalRequired,
    });
    const finalIsSuccess = !finalIsLoading && allTotalsFetched;

    return {
        data: combinedData,
        isLoading: finalIsLoading,
        isSuccess: finalIsSuccess,
        isError: !finalIsSuccess,
        error: null,
    };
};

